<template>
	<div>
		<div class="main-header">
			<div class="container">
				<h2 class="main-header-text">{{mode=="add" ? "Create New" : "Edit"}} Recipient</h2>
			</div>
		</div>
		<div class="main-section mgt-40">
			<div class="container">
				<div class="main-card">
					<img src="/static/img/icons/arrow-down-indicator-red.png" alt="" class="top-indicator" />
					<form @submit.prevent="onSubmit" novalidate="">
						<div class="SetupOneWrapper">
							<div class="form-card">
								<div class="form-card-header">
									<h3>Payment Details </h3>
									<img src="/static/img/icons/western-union-logo.png">
								</div>
								<div class="form-card-forms">
									<div v-if="mode!='edit' && IsSetupOne">
										<div class="row">
											<div class="col-md-4">
												<div class="form-group">
													<label for="">
														Country
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<select class="form-control" name="CountryId"
															v-model="vModel.CountryId" v-validate="'required'"
															@change="onChangeCountry" data-vv-as='Country'>
															<option value="">Select</option>
															<option v-for="option in CountryCollection" :key="option.Id"
																:value="option.Id">
																{{option.Text}}
															</option>
														</select>


														<div v-show="errors.has('CountryId')" class="help is-danger">
															{{ errors.first('CountryId') }}</div>
													</div>
												</div>
											</div>

											<div class="col-md-4">
												<div class="form-group">
													<label for="">
														Payment Mode
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<select class="form-control" name="PayoutModeId"
															v-model="vModel.PayoutModeId" v-validate="'required'"
															@change="onChangeDeliveryOption" data-vv-as='Payout mode'>
															<option value="">Select</option>
															<option v-for="option in PaymentMethods" :key="option.Id"
																:value="option.Id">
																{{option.Text}}
															</option>
														</select>


														<div v-show="errors.has('PayoutModeId')" class="help is-danger">
															{{ errors.first('PayoutModeId') }}</div>
													</div>
												</div>
											</div>
											<div class="col-md-4">
												<div class="form-group">
													<label for="">
														Currency
														<span class="required">*</span>
													</label>
													<div class="mb-3">

														<select class="form-control" name="CurrencyId"
															v-model="vModel.CurrencyId" v-validate="'required'"
															@change="onChangeCurrency" data-vv-as='Currency'>
															<option value="">Select</option>
															<option v-for="option in CurrencyCollection"
																:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>

														<div v-show="errors.has('CurrencyId')" class="help is-danger">
															{{ errors.first('CurrencyId') }}</div>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div v-else>
										<div class="row">
											<div class="col-md-4">
												<div class="form-group">
													<label for="">
														Country
													</label>
													<div class="input-group mb-3">
														<img :src="'/images/flags/'+vModel.FlagCode+'.png'"
														class="mr-1" style="margin-top:-12px;" /> {{vModel.CountryName}}
													</div>
												</div>
											</div>
											<div class="col-md-4">
												<div class="form-group">
													<label for="">
														Payout Mode

													</label>
													<div class="input-group mb-3">
														{{vModel.PayoutModeName}}
													</div>
												</div>

											</div>
											<div class="col-md-4">
												<div class="form-group">
													<label for="">
														Currency

													</label>
													<div class="input-group mb-3">
														{{vModel.CurrencyName}}
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="submit-option" v-if="IsSetupOne">
							<div class="left-option">
								<button class="btn submit-lefticon-btn" @click="onCancel()" type="button">
									<span class="left-icon">
										<i class="material-icons">chevron_left</i>
									</span>
									<span class="btn-content">Cancel</span>
								</button>
							</div>
							<div class="right-option">
								<button class="btn submit-righticon-btn">
									<span class="btn-content">Next</span>
									<span class="right-icon">
										<i class="material-icons">chevron_right</i>
									</span>
								</button>
							</div>
						</div>
						<div v-else>
							<div v-if="vModel.PayoutModeId == '98'">
								<div class="form-card">
									<div class="form-card-header">
										<h3>Bank Details</h3>
									</div>
									<div class="form-card-forms">
										<form-generator :schema="bankSection" v-model="D2BData">
										</form-generator>
									</div>
								</div>
							</div>
							<div>
								<div class="form-card">
									<div class="form-card-header">
										<h3>Reciever Details</h3>
									</div>
									<div class="form-card-forms">
										<div class="row">
											<div class="col-lg-4"
												v-if="FieldValidation != null && FieldValidation.FirstName != null">
												<div class="form-group">
													<label for="">
														First Name
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														id="FirstName" name="FirstName" autocomplete="off"
														v-model="vModel.FirstName" v-validate="'required|max:100'"
														:data-vv-as='FieldValidation.FirstName.WebRequiredMessage'
														v-only-text="" v-only-uppercase />

													<div v-show="errors.has('FirstName')" class="help is-danger">
														{{errors.first('FirstName') }} </div>
												</div>
											</div>
											<div class="col-lg-4"
												v-if="FieldValidation != null && FieldValidation.MiddleName != null">
												<div class="form-group">
													<label for="">Middle Name</label>
													<input type="text" class="form-control text-uppercase"
														name="MiddleName" autocomplete="off" v-validate="'max:100'"
														:data-vv-as='FieldValidation.MiddleName.WebRequiredMessage'
														v-model="vModel.MiddleName" v-only-text v-only-uppercase />

													<div v-show="errors.has('MiddleName')" class="help is-danger">
														{{ errors.first('MiddleName') }}</div>
												</div>
											</div>
											<div class="col-lg-4"
												v-if="FieldValidation != null && FieldValidation.LastName != null">
												<div class="form-group">
													<label for="">
														Last Name
														<span v-if="FieldValidation.LastName.Required == true"
															class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														name="LastName" autocomplete="off" v-model="vModel.LastName"
														v-validate="FieldValidation.LastName.Required == true ? 'required|max:100': ''"
														:data-vv-as='FieldValidation.LastName.WebRequiredMessage'
														v-only-text="" v-only-uppercase />

													<div v-show="errors.has('LastName')" class="help is-danger">
														{{ errors.first('LastName') }}
													</div>
												</div>
											</div>
											<div class="col-lg-4"
												v-if="FieldValidation != null && FieldValidation.RelationshipId != null">
												<div class="form-group">
													<label for="">
														Relationship
														<span class="required">*</span>
													</label>
													<div class="mb-3">

														<select class="form-control" name="RelationShipId" @change="onChangeRelationship"
															v-model="vModel.RelationShipId" v-validate="'required'"
															:data-vv-as='FieldValidation.RelationshipId.WebRequiredMessage'>
															<option :value="null">Select</option>
															<option v-for="option in RelationShipCollection"
																:key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('RelationShipId')"
															class="help is-danger">{{ errors.first('RelationShipId') }}
														</div>
														<div v-show="showAdditionalRelationshipMessage"
																class="help is-danger">
																{{ additionalRelationshipMessage }}</div>


													</div>
												</div>
											</div>
											<!-- <div class="col-lg-4">
												<div class="form-group">
													<label for="">
														Occupation
														<span class="required">*</span>
													</label>
													<div class="mb-3">

														<select class="form-control" name="OccupationId" v-model="vModel.OccupationId" v-validate="'required'"
														 :data-vv-as='Occupation'>
															<option value="">Select</option>
															<option v-for="option in OccupationCollection" :key="option.Id" :value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('OccupationId')" class="help is-danger">{{ errors.first('OccupationId') }}</div>



													</div>
												</div>
											</div> -->
											<div class="col-lg-4"
												v-if="(FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId != 251) || (FieldValidation != null && FieldValidation.MobileContact != null && vModel.CountryId == 251 && vModel.PayoutModeId == 97)">
												<div class="form-group">
													<label for="">
														Mobile Number
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control" name="MobileContact"
														autocomplete="off" v-mobile-normal="" maxlength="18"
														v-model="vModel.MobileContact"
														:data-vv-as='FieldValidation.MobileContact.WebRequiredMessage'
														v-validate="'required|max:18|mobile'"
														:class="{'input': true, 'is-danger': errors.has('MobileContact') }" />
													<div v-show="errors.has('MobileContact')" class="help is-danger">
														{{ errors.first('MobileContact') }}
													</div>
												</div>
											</div>


											<!-- <div class="col-md-4" v-if="vModel.CountryId != 251 && vModel.CountryId != 159">
												<div class="form-group">
													<label for="">
														State
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="StateName" autocomplete="off" v-model="vModel.StateName"
													 :data-vv-as='State' v-validate="'required|max:25'" :class="{'input': true, 'is-danger': errors.has('StateName') }" />
													<div v-show="errors.has('StateName')" class="help is-danger">
														{{ errors.first('StateName') }}
													</div>
												</div>
											</div> -->
											<div class="col-md-4"
												v-if="FieldValidation != null && FieldValidation.StateId != null">
												<div class="form-group">
													<label for="">
														State
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<select class="form-control" name="StateId"
															v-model="vModel.StateId" v-validate="'required'"
															@change="onChangeState"
															:data-vv-as='FieldValidation.StateId.WebRequiredMessage'>
															<option value="">Select</option>
															<option v-for="option in StatesCollection" :key="option.Id"
																:value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('StateId')" class="help is-danger">
															{{ errors.first('StateId') }}</div>
													</div>
												</div>
											</div>
											<div class="col-md-4"
												v-if="FieldValidation != null && FieldValidation.City != null && vModel.CountryId != 159">
												<div class="form-group">
													<label for="">
														City
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="City"
														autocomplete="off" v-model="vModel.City"
														:data-vv-as='FieldValidation.City.WebRequiredMessage'
														v-validate="'required|max:50'"
														:class="{'input': true, 'is-danger': errors.has('City') }"
														v-only-uppercase />
													<div v-show="errors.has('City')" class="help is-danger">
														{{ errors.first('City') }}
													</div>
												</div>
											</div>
											<div class="col-md-4"
												v-if="FieldValidation != null && FieldValidation.City != null && vModel.CountryId == 159 && vModel.PayoutModeId == 97">

												<div class="form-group">
													<label for="">
														City
														<span class="required">*</span>
													</label>
													<div class="mb-3">
														<select class="form-control" name="CityId" v-model="vModel.City"
															v-validate="'required'"
															:data-vv-as='FieldValidation.City.WebRequiredMessage'>
															<option value="">Select</option>
															<option v-for="option in MexicoCities" :key="option.Id"
																:value="option.Id">
																{{option.Text}}
															</option>
														</select>
														<div v-show="errors.has('CityId')" class="help is-danger">
															{{ errors.first('CityId') }}</div>
													</div>
												</div>
											</div>
											<div class="col-md-4"
												v-if="FieldValidation != null && FieldValidation.PostCode != null">
												<div class="form-group">
													<label for="">
														Post Code
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase"
														name="PostCode" autocomplete="off" v-model="vModel.PostCode"
														:data-vv-as='FieldValidation.PostCode.WebRequiredMessage'
														v-validate="'required'"
														:class="{'input': true, 'is-danger': errors.has('PostCode') }" />
													<div v-show="errors.has('PostCode')" class="help is-danger">
														{{ errors.first('PostCode') }}
													</div>
												</div>
											</div>
											<div class="col-md-4"
												v-if="FieldValidation != null && FieldValidation.Street != null">
												<div class="form-group">
													<label>
														Street Address
														<span class="required">*</span>
													</label>
													<input type="text" class="form-control text-uppercase" name="Street"
														autocomplete="off" v-model="vModel.Street"
														v-validate="'required|max:75'"
														:data-vv-as='FieldValidation.Street.WebRequiredMessage'
														:class="{'input': true, 'is-danger': errors.has('Street') }"
														v-only-uppercase />
													<div v-show="errors.has('Street')" class="help is-danger">
														{{ errors.first('Street') }}
													</div>
												</div>
											</div>
										</div>
										<div v-if="vModel.PayoutModeId == '98'">
											<form-generator :schema="recipientSection" v-model="D2BData">
											</form-generator>
										</div>
									</div>
								</div>
							</div>
							<div class="submit-option">
								<div class="left-option">
									<router-link :to="'/recipient/westernunion'" class="btn submit-lefticon-btn">
										<span class="left-icon">
											<i class="material-icons">chevron_left</i>
										</span>
										<span class="btn-content">Cancel</span>
									</router-link>
								</div>
								<div class="right-option">
									<button class="btn submit-righticon-btn">
										<span class="btn-content">{{mode=="add" ? "Create" : "Update"}}</span>
										<span class="right-icon">
											<i class="material-icons">chevron_right</i>
										</span>
									</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Base from "../../shared/Base.vue";
	import Action from "../../shared/Action.vue";
	import Mode from "../../shared/Mode.vue";
	import ListService from "../../services/list";
	import FormGenerator from "../../formcomponents/FormGenerator.vue";
	import {
		_
	} from 'vue-underscore';

	export default {
		name: "WesterUnion",
		extends: Base,
		components: {
			Action,
			Mode,
			FormGenerator
		},
		created() {
			this.url.add = "recipient/westernunion/save";
			this.url.edit = "recipient/westernunion/edit";
			this.url.update = "recipient/westernunion/save";
			this.url.delete = "recipient/westernunion/delete";
		},
		beforeRouteEnter(to, from, next) {
			var promises = [ListService.get("list/westernunion/country"),
			//ListService.get("list/westernunion/statebycountryid/251"), //USA
			//ListService.get("list/westernunion/statebycountryid/159"), //Mexico
			ListService.get("list/relationship/edit/97/"+to.params.id),
			ListService.get("list/occupation")
			];
			if (to.params.id != undefined) {
				promises.push(ListService.getById("recipient/westernunion/get/" + to.params.id));
				promises.push(ListService.getFeildValidateByWUBeneficiary(to.params.id));
				Promise.all(promises).then(response => {
					next(p => {
						p.fromPath = from.path;
						p.IsSetupOne = false;
						p.CountryCollection = response[0].body;
						p.RelationShipCollection = response[1].body;
						//westernUnion Invalid Relationship
						if (response[3].body.RelationShipId == 7 || response[3].body.RelationShipId == 8 || response[3].body.RelationShipId == 15 || response[3].body.RelationShipId == 16 || response[3].body.RelationShipId == 17 ){
							response[3].body.RelationShipId = null;
            			}
						p.OccupationCollection = response[2].body;
						p.vModel = response[3].body;
						//Pakistan Invalid Relationships
						if (response[3].body.CountryId == 7 && (response[3].body.RelationShipId == 11 || response[3].body.RelationShipId == 12)){
              				p.vModel.RelationShipId = null;
            			}
						p.D2BData = JSON.parse(response[3].body.D2BData);
						p.schema = response[3].body.schema;
						p.FieldValidation = response[4].body;
						if (response[3].body.schema) {
							p.bankSection = response[3].body.schema.BankDetails;
							p.recipientSection = response[3].body.schema.PersonalDetails;
						}
					});
				});

			} else {
				promises.push(ListService.getFeildValidateByWUBeneficiary(to.params.id));
				Promise.all(promises).then(response => {
					next(p => {
						p.CountryCollection = response[0].body;
						p.RelationShipCollection = response[1].body;
						p.OccupationCollection = response[2].body;
						p.FieldValidation = response[3].body;
					});
				});
			}
		},
		data() {
			return {
				additionalRelationshipCollection: [7, 8, 15, 16, 17],
				showAdditionalRelationshipMessage: false,
				additionalRelationshipMessage: `3rd party relationship selected. On behalf, details will be required during the transaction.`,
				fromPath: null,
				CountryCollection: [],
				CurrencyCollection: [],
				PaymentMethods: [],
				StatesCollection: [],
				OccupationCollection: [],
				RelationShipCollection: [],
				MexicoStates: [],
				USStates: [],
				IsSetupOne: true,
				RelationShipCollection: [{
					Id: '1',
					Text: 'TEST'
				}],
				MexicoCities: [],
				vModel: {
					Id: null,
					CountryId: '',
					CountryName: '',
					CurrencyId: '',
					Currency: '',
					CountryName: '',
					PayoutModeId: '',
					PayoutModeName: '',
					Currency: '',
					FirstName: '',
					MiddleName: '',
					LastName: '',
					RelationShipId: null,
					MobileContact: '',
					Street: '',
					PostCode: '',
					StateName: '',
					StateId: '',
					CityName: '',
					CityId: '',
					OccupationId: '',
					CurrencyName: '',
					FlagCode: ''
				},
				D2BData: {},
				schema: [],
				bankSection: [],
				recipientSection: [],
				FieldValidation: null
			};
		},

		watch: {
			"vModel.CountryId": function (newValue, oldVlaue) {

				var promises = [];

				promises.push(ListService.getById("list/westernunion/statebycountryid/" + newValue));


				Promise.all(promises).then(response => {

					if (response[0]) {
						this.StatesCollection = response[0].body;

						if (newValue == '159' && this.vModel.StateId && this.vModel.PayoutModeId == '97') {

							var selectedState = this.StatesCollection.filter(x => {
								return x.Id == this.vModel.StateId;
							})[0];

							this.MexicoCities = selectedState.Cities;
						}
					}
				});



			}
		},

		methods: {

			onChangeState() {

				this.vModel.City = '';
				this.vModel.CityId = '';
				if (this.vModel.CountryId == '159' && this.vModel.StateId != '') {

					var selectedState = this.StatesCollection.filter(p => {
						return p.Id == this.vModel.StateId;
					})[0];

					this.MexicoCities = selectedState.Cities;
				}
			},
			onChangeCurrency() {
				if (this.vModel.CurrencyId != '') {

					var selectedCurrency = this.CurrencyCollection.filter(p => {
						return p.Id == this.vModel.CurrencyId;
					})[0];

					this.vModel.CurrencyName = selectedCurrency.Text
				}
			},

			onChangeDeliveryOption() {

				if (this.vModel.PayoutModeId != '') {
					var selectedCountry = this.CountryCollection.filter(p => {
						return p.Id == this.vModel.CountryId;
					})[0];

					var selectedPayment = selectedCountry.PaymentMethods.filter(p => {
						return p.Id == this.vModel.PayoutModeId;
					})[0];

					this.vModel.PayoutModeName = selectedPayment.Text;

					if (this.vModel.PayoutModeId == "98") {
						ListService.get("recipient/westernunion/d2bform/" + selectedCountry.Code).then(res => {
							this.D2BData = JSON.parse(res.body.D2BData);
							this.schema = res.body.schema;
							this.bankSection = res.body.schema.BankDetails
							this.recipientSection = res.body.schema.PersonalDetails

						});
					}
				}
			},

			onChangeCountry: function () {
				this.CurrencyCollection = [];
				this.PaymentMethods = [];
				this.StatesCollection = [];
				this.schema = [];

				this.vModel.CurrencyId = '';
				this.vModel.PayoutModeId = '';



				if (this.vModel.CountryId != null && this.vModel.CountryId != "") {

					var selectedCountry = this.CountryCollection.filter(p => {
						return p.Id == this.vModel.CountryId;
					})[0];

					this.vModel.CountryName = selectedCountry.Text;

					this.CurrencyCollection = selectedCountry.Currencies;
					this.PaymentMethods = selectedCountry.PaymentMethods;

				}

			},

			onSubmit: function () {
				this.$validator.validateAll().then(result => {

					if (result) {
						if (this.IsSetupOne) {
							this.IsSetupOne = false;
						} else {
							var url = "";
							if (this.vModel.Id) {
								url = this.url.update;
							} else {
								url = this.url.add;
							}
							this.isProcessing = true;
							var post = Object.assign({}, this.vModel);
							post["D2BData"] = JSON.stringify(this.D2BData);
							delete post.schema;
							this.$http.post(url, post).then(
								response => {

									if (this.vModel.Id) {
										this.$toastr("success", "Updated Successfully");
									} else {
										this.$toastr("success", "Created Successfully");
									}
									if (this.fromPath = '/transaction')
										this.$router.push("/recipient/westernunion");
									else
										this.$router.push("/recipient/westernunion");
									this.isProcessing = false;
								},
								error => {
									this.isProcessing = false;
								}
							);
						}
					}
				});

			},
			onCancel: function () {
				this.$router.push("/recipient/westernunion");
			},
			onChangeRelationship: function(evt){
				var relationshipId = evt.target.value;
				if(relationshipId && additionalRelationshipCollection.includes(relationshipId))
				this.showAdditionalRelationshipMessage = true;
				else
				this.showAdditionalRelationshipMessage = false;
			}
		}
	};
</script>

<style>
	.form-card-header {
		padding: 0px 15px 75px 15px !important;
	}

	.form-card-header img {
		float: right;
		height: 75px;
	}

	.form-card-header h3 {
		float: left;
		height: 75px;
		padding-top: 25px;
	}
</style>
<style scoped>
	select.form-control {
		-webkit-appearance: menulist !important;
	}
</style>